import i18nTag from 'es2015-i18n-tag'
import moment from 'moment'
import ptLocalization from 'moment/locale/pt'
import am4lang_en_US from '@amcharts/amcharts4/lang/en_US'
import am4lang_pt_PT from '@amcharts/amcharts4/lang/pt_PT'

import 'localization/en'
import 'localization/pt'

const momentLocalizations = {
	pt: ptLocalization,
}

const dateTimeFormats = {
	en: {
		date: 'MMM DD, YYYY',
		tiny: 'MM/DD/YY',
		small: 'MM/DD/YYYY',
		time: 'HH:mm',
		dateTime: 'MMM DD, YYYY [at] HH:mm',
	},
	pt: {
		date: 'DD MMM YYYY',
		tiny: 'DD/MM/YY',
		small: 'DD/MM/YYYY',
		time: 'HH:mm',
		dateTime: 'DD MMM YYYY, HH:mm[h]',
	},
}

const amChartsLocales = {
	pt: am4lang_pt_PT,
	en: am4lang_en_US,
}

const availableLocales = ['en', 'pt']

// const systemLanguage = navigator.language.split('-')[0]
// const systemLocale = availableLocales.includes(systemLanguage)
// 	? systemLanguage
// 	: null
const locale =
	localStorage.getItem('locale') ||
	sessionStorage.getItem('locale') ||
	// systemLocale ||
	'pt'

if (momentLocalizations[locale]) {
	moment.updateLocale(locale, momentLocalizations[locale])
}
moment.locale(locale)
const i18n = i18nTag('', locale)
const dateTimeFormat = dateTimeFormats[locale] || dateTimeFormats.en
const amChartsLocale = amChartsLocales[locale] || amChartsLocales.en
export {
	i18n,
	moment,
	availableLocales,
	locale,
	dateTimeFormat,
	amChartsLocale,
}
